// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userDetails_submitBtn__9eIhd {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  background: rgba(30, 229, 118, 1) !important;
  padding: 10px !important;
  border-radius: 20px !important;
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

:root {
  --accent-green: rgba(30, 229, 118, 1); /* same as submitBtn */
  --text-dark: #000000;
  --table-bg: #ffffff;
  --table-header-bg: #046A38;
  --table-header-border: rgba(30, 229, 118, 0.30);
  --table-row-hover: rgba(30, 229, 118, 0.08);
  --table-border: #e9ecef; /* close to Bootstrap's border color */
}

.userDetails_table-theme__TH1nM {
  font-family: "DM Sans", sans-serif;
  color: var(--text-dark);
}

.userDetails_table-theme__TH1nM .userDetails_table-card__qDSaS {
  background: var(--table-bg);
  border: 1px solid var(--table-border);
  /* border-radius: 16px; */
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
}

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA {
  margin: 0;
  border-collapse: separate;       
  border-spacing: 0;
}

/* .table-theme .table thead tr:first-child th:first-child {
  border-top-left-radius: 16px;
}
.table-theme .table thead tr:first-child th:last-child {
  border-top-right-radius: 16px;
}
.table-theme .table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 16px;
}
.table-theme .table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 16px;
} */

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA thead th {
  background: var(--table-header-bg);
  border-bottom: 2px solid var(--table-header-border);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-transform: none;
}

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody td,
.userDetails_table-theme__TH1nM .userDetails_table__nyIAA thead th {
  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */
}

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody tr:hover {
  background: var(--table-row-hover);
}

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody tr + tr td {
  border-top: 1px solid var(--table-border);
}

.userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody td.userDetails_id-col__g9YmY {
  color: var(--text-dark);
  font-weight: 500;
}

.userDetails_table-theme__TH1nM .userDetails_badge-accent__wLK7r {
  display: inline-block;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #0f7a4d; /* readable on light background */
  background: rgba(30, 229, 118, 0.18);
  border: 1px solid rgba(30, 229, 118, 0.35);
}

.userDetails_table-theme__TH1nM .userDetails_btn-outline-accent__2N4gE {
  color: var(--text-dark);
  border-radius: 100px;
  border: 1px solid rgba(0,0,0,0.12);
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
}
.userDetails_table-theme__TH1nM .userDetails_btn-outline-accent__2N4gE:hover {
  border-color: rgba(30, 229, 118, 0.8);
  color: #0f7a4d;
  background: rgba(30, 229, 118, 0.08);
}

.userDetails_table-theme__TH1nM .userDetails_btn-accent__tHEmO {
  color: var(--text-dark) !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-align: center !important;
  background: var(--accent-green) !important;
  padding: 10px 18px;                
  border-radius: 100px !important;
  border: none !important;
  cursor: pointer !important;
}

@media (max-width: 576px) {
  .userDetails_table-theme__TH1nM .userDetails_table__nyIAA thead th,
  .userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody td {
    padding: 12px 12px;
    font-size: 13px;
  }
  .userDetails_table-theme__TH1nM .userDetails_table__nyIAA thead th:last-child,
  .userDetails_table-theme__TH1nM .userDetails_table__nyIAA tbody td:last-child {
    white-space: nowrap;
  }
}

/**Pagination **/
.userDetails_pagination-wrapper__NUJaA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 16px 0;
  flex-wrap: wrap;
  gap: 16px;
}

.userDetails_pagination__V3WhT {
  display: flex;
  gap: 8px;
  align-items: center;
}

.userDetails_page-btn__ZDtpQ {
  border: 1px solid #e5e7eb;
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fff;
  color: #374151;
  transition: all 0.2s ease;
  min-height: 40px;
  min-width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
}

.userDetails_page-btn__ZDtpQ:hover:not(:disabled):not(.userDetails_active__4Ly5R) {
  background-color: rgba(30, 229, 118, 0.08);
  border-color: rgba(30, 229, 118, 0.3);
  color: #046A38;
}

.userDetails_page-btn__ZDtpQ.userDetails_active__4Ly5R {
  background-color: #046A38;
  color: #ffffff;
  border-color: #046A38;
  font-weight: 600;
}

.userDetails_page-btn__ZDtpQ:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.userDetails_nav-btn__sGOW6 {
  border-radius: 8px;
  padding: 0;
}

.userDetails_nav-btn__sGOW6 svg {
  display: block;
}

.userDetails_ellipsis__GFNZP {
  color: #9ca3af;
  padding: 0 4px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.userDetails_pagination-info__Myft1 {
  color: #6b7280;
  font-size: 14px;
  font-weight: 400;
  font-family: "DM Sans", sans-serif;
}

@media (max-width: 640px) {
  .userDetails_pagination-wrapper__NUJaA {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .userDetails_pagination-info__Myft1 {
    order: -1;
    width: 100%;
  }
}
/**Pagination **/

/**Common add/edit modal css**/

.userDetails_modal__nfq1X {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}
div.userDetails_userDetailsModal__Gmxhj {
  padding: 0 !important;
  z-index: 9999;
}
/* Modal Content */
.userDetails_modal-content__-KW69 {
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
}

body.userDetails_modal-open__MgBCm {
  padding: 0 !important;
}
.userDetails_lead-form__1C2oy .userDetails_form-label__kM8nD {
  margin: 16px 0 0 0;
}

.userDetails_lead-form__1C2oy label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
  color: rgba(102, 102, 102, 1);
}

/* .lead-form input[type="text"],
.lead-form input[type="email"],
.lead-form input[type="number"] {
  border-left: none;
  border-right: none;
  outline: none;
  border-radius: 0;
  border-top: none;
  padding: 5px 0;
  box-shadow: unset;
} */

.userDetails_passwordInputs__COdS8 {
  border-bottom: 1px solid #8C8C8C !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-radius: 0 !important;
}

.userDetails_formInput__HnGqC.userDetails_passwordInputs__COdS8:focus {
  box-shadow: none !important;
}

.userDetails_branchSelect__rpnVP {
  min-height: 35px ;
  cursor: pointer;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj p:nth-child(2) {
  font-family: "Inter", sans-serif;
  font-size: 12px !important;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  color: #000000;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj p:nth-child(1) span {
  font-family: "Inter", sans-serif;
  letter-spacing: normal;
  font-size: 12px;
  color: #666;
  font-weight: 400;
  line-height: 18px
}

.userDetails_userDetailsModal__Gmxhj form.userDetails_userDetailsModal__Gmxhj .userDetails_row__GtKQo.userDetails_mt-4__xwesH:has(.userDetails_col-md-1__bn6AE) {
  margin-top: 16px !important;
  align-items: center !important;
}

.userDetails_userDetailsModal__Gmxhj label {
  font-family: "Inter", sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
  color: #222222 !important;
  display: inline-block;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_form-control__kPmXm {
  padding: 0 !important;
  border-bottom-color: #8C8C8C;
}

#userDetails_editUserModal__IIdbg .userDetails_submitBtn__9eIhd:focus {
    outline: 2px solid #222 !important;
    outline-offset: 0px;
    background-color: #00b140 !important;
}
#userDetails_addUserModal__jOP-Y .userDetails_submitBtn__9eIhd:focus {
    outline: 2px solid #222 !important;
    outline-offset: 0px;
    background-color: #00b140 !important;
}
#userDetails_loading-image__fwDHS{
  color: #000000;
}

.userDetails_lead-form__1C2oy button {
  color: #000000 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: normal !important;
  text-align: center !important;
  /* background: rgba(30, 229, 118, 1) !important; */
  padding: 16px 35%;
  /* border-radius: 100px !important; */
  border: none !important;
  cursor: pointer !important;
  margin-top: 0;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj p span {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 19.6px;
  color: #414141;
  font-weight: 400;
  text-align: left;
  letter-spacing: normal;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv {
  position: absolute;
  right: 32px;
  top: 32px;
  width: 35px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: pointer;
  background: none;
  opacity: 1;
  border: 0;
}
.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:focus,
.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:focus-visible {
   outline: 2px solid black;
    outline-offset: 2px;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:before,
.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:after {
  position: absolute;
  top: 0;
  content: ' ';
  height: 24px;
  width: 3px;
  background-color: #333;
  display: inline-block;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:before {
  transform: rotate(45deg);
}

.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:after {
  transform: rotate(-45deg);
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-header__HInqw {
  border-bottom: 0;
  padding: 54px 56px 0 56px;
  padding: 0;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj {
  /* max-height: 60vh; */
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding-left: 5px;
}

.userDetails_lead-form__1C2oy input[type="text"],
.userDetails_lead-form__1C2oy input[type="email"],
.userDetails_lead-form__1C2oy input[type="number"] {
  min-height: 35px !important;
}

/* width */
.userDetails_userDetailsModal__Gmxhj::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-thumb {
  background: #414141;
}

/* Handle on hover */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.userDetails_bg-green__RUUyc{
      background-color:  rgba(30, 229, 118, 1)  !important;
    border: none !important;
    color: #000000 !important;
}
.userDetails_userDetailsModal__Gmxhj .userDetails_modal-title__MMWG0 {
  font-family: "DM Sans",sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 52.8px;
  letter-spacing: normal;
  text-align: left;
  color: #222222;
}

.userDetails_userDetailsModal__Gmxhj span#userDetails_myModalClose__brPnZ {
  border-radius: 0;
  padding: 0 !important;
  margin-right: 10px !important;
}

.userDetails_userDetailsModal__Gmxhj.userDetails_show__lrV-1{
  display: block !important;
}

/* width */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-thumb {
  background: #414141;
}

/* Handle on hover */
.userDetails_userDetailsModal__Gmxhj ::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.userDetails_modal__nfq1X {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: unset;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.userDetails_modal-content__-KW69 {
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
}

.userDetails_modal-backdrop__jj43V {
  display: none;
}

.userDetails_modal__nfq1X,
.userDetails_modal-open__MgBCm {
  background: rgba(0, 0, 0, .5);
  overflow: hidden
}

.userDetails_modal__nfq1X {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  outline: 0
}

.userDetails_modal-open__MgBCm .userDetails_modal__nfq1X {
  overflow-x: hidden;
  overflow-y: auto
}

.userDetails_modal-dialog__naTCE {
  position: relative;
  width: auto;
  margin: 8px !important;
  pointer-events: none
}

.userDetails_modal__nfq1X.userDetails_fade__AZ8a3 .userDetails_modal-dialog__naTCE {
  transition: transform .3s ease-out;
  transform: translateY(-25%)
}

.userDetails_modal__nfq1X.userDetails_show__lrV-1 .userDetails_modal-dialog__naTCE {
  transform: translate(0)
}

.userDetails_modal-dialog-centered__93EQh {
  display: flex;
  align-items: center;
  min-height: calc(100% - 16px)
}

.userDetails_modal-content__-KW69 {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(28, 28, 28, .2);
  border-radius: 16px;
  outline: 0
}

.userDetails_modal-backdrop__jj43V {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #1c1c1c
}

.userDetails_modal-backdrop__jj43V.userDetails_fade__AZ8a3 {
  opacity: 0
}

.userDetails_modal-backdrop__jj43V.userDetails_show__lrV-1 {
  opacity: .5
}

.userDetails_modal-header__HInqw {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.userDetails_modal-title__MMWG0 {
  margin-bottom: 0;
  line-height: 1.55
}

.userDetails_modal-body__Hjlmj {
  position: relative;
  flex: 1 1 auto;
  padding: 16px
}

.userDetails_modal-footer__CuS5b {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid #e9ecef
}

.userDetails_modal-footer__CuS5b>:not(:first-child) {
  margin-left: .25rem
}

.userDetails_modal-footer__CuS5b>:not(:last-child) {
  margin-right: .25rem
}

.userDetails_modal-scrollbar-measure__t5gKa {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll
}

.userDetails_modal-content__-KW69 {
  color: #00703c
}

.userDetails_modal-content__-KW69 .userDetails_modal-body_title__CTMtP {
  color: #00703c;
  font-size: 36px
}

.userDetails_modal-header__HInqw {
  border-bottom: none
}

.userDetails_modal-body__Hjlmj {
  padding: 44px 16px 100px
}

.userDetails_modal-section-padding__ye6DC {
  padding-right: 17px
}
.userDetails_userDetailsModal__Gmxhj .userDetails_submitBtn__9eIhd{
  height: auto;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_submitBtn__9eIhd:hover, #userDetails_editUserModal__IIdbg .userDetails_submitBtn__9eIhd:focus {
  background-color: #00B140 !important;
}
.userDetails_userDetailsModal__Gmxhj .userDetails_modal-content__-KW69{
  padding: 64px 56px 56px;
  border-radius: 16px;
}


.userDetails_show__lrV-1 {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .userDetails_lead-form__1C2oy button#userDetails_submit_lead_data__I6Rrs {
    margin-top: 4px !important;
    padding: 13px 0px;
    width: 100%;
  }
}

@media (min-width:576px) {
  .userDetails_modal-dialog__naTCE {
    max-width: 500px;
    margin: 28px auto !important;
    padding: 0;
  }

  .userDetails_modal-dialog-centered__93EQh {
    min-height: calc(100% - 56px)
  }

  .userDetails_modal-sm__FANAl {
    max-width: 300px
  }
}

@media (max-width: 767px) {

  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-title__MMWG0 {
    font-size: 36px !important;
    line-height: 38.52px !important;
  }
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-content__-KW69 .userDetails_modal-header__HInqw{
    padding: 24px 16px 16px;
  }
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj {
    padding: 0 16px 16px;
  }
  .userDetails_userDetailsModal__Gmxhj .userDetails_call-now-mob__21qy4.userDetails_d-block__y4bJ0 {
    background: #000;
    color: #fff !important;
    width: 100%;
    display: block !important;
    padding: 16px 0;
    border-radius: 40px;
    text-align: center;
    text-decoration: none;
    margin-bottom: 26px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    text-transform: capitalize;
    font-family: "DM Sans", sans-serif;
    letter-spacing: normal;
  }
  .userDetails_userDetailsModal__Gmxhj .userDetails_submitBtn__9eIhd {
    max-width: 100%;
    width: 100%;
  }

  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-content__-KW69{
    padding: 64px 16px 32px;
  }
}

@media (min-width:720px) and (max-width:766px) {
  button#userDetails_submit_lead_data__I6Rrs {
    width: 100%;
  }
}

@media screen and (min-width: 992px) {
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-dialog__naTCE {
    max-width: 800px !important;
  }
}

@media (min-width:720px) and (max-width:766px) {
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-dialog__naTCE {
    max-width: 500px !important;
  }
}

@media (min-width:768px) and (max-width:991px) {
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-dialog__naTCE {
    max-width: 700px;
  }

  .userDetails_userDetailsModal__Gmxhj .userDetails_show__lrV-1 {
    display: block !important;
  }
}


@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-content__-KW69 {
    width: 100% !important;
  }

  .userDetails_userDetailsModal__Gmxhj .userDetails_modal-title__MMWG0 {
    font-size: 48px !important;
  }
}

.userDetails_invalid-feedback__aYESy{
  color: #D22B2B !important;
  width: 100%;
  margin-top: 4px !important;
  font-size: 12px !important;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  line-height: 18px;
  /* display: none; */
}
.userDetails_userDetailsModal__Gmxhj .userDetails_btn-close__axaxv:focus{
  outline: 2px solid transparent !important;
  box-shadow: none !important;
}

/**Common add/edit modal css**/

/* MultiSelect Dropdown Styles */
.userDetails_tg-multiselect__kNVAu {
  position: relative !important;
  z-index: 1000 !important;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_tg-multiselect__kNVAu {
  z-index: 1001 !important;
}

.userDetails_tg-multiselect-panel__xymgW {
  z-index: 10000 !important;
  max-width: 90vw !important;
}

/* Ensure modal body doesn't clip the dropdown */
.userDetails_userDetailsModal__Gmxhj .userDetails_modal-dialog__naTCE {
  overflow: visible !important;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-content__-KW69 {
  overflow: visible !important;
}

.userDetails_userDetailsModal__Gmxhj .userDetails_modal-body__Hjlmj {
  overflow: visible !important;
  position: relative;
  z-index: auto;
}

/* Responsive styles for MultiSelect */
@media (max-width: 576px) {
  .userDetails_tg-multiselect-panel__xymgW {
    max-width: 85vw !important;
    max-height: 250px !important;
  }
  
  .userDetails_userDetailsModal__Gmxhj .userDetails_col-md-6__kLSx3 {
    position: relative;
    z-index: 1001;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .userDetails_tg-multiselect-panel__xymgW {
    max-width: 80vw !important;
    max-height: 300px !important;
  }
}

@media (min-width: 769px) {
  .userDetails_tg-multiselect-panel__xymgW {
    max-width: auto !important;
    max-height: 400px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/userDetails/userDetails.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,4CAA4C;EAC5C,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,qCAAqC,EAAE,sBAAsB;EAC7D,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,+CAA+C;EAC/C,2CAA2C;EAC3C,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,kCAAkC;EAClC,mDAAmD;EACnD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB,EAAE,wDAAwD;AAC7E;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,iCAAiC;EACjD,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA,gBAAgB;;AAEhB,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;AACxC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,kDAAkD;EAClD,iBAAiB;EACjB,qCAAqC;EACrC,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;;GAEG,wBAAwB;IACvB,mBAAmB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;MACM,oDAAoD;IACtD,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,6BAA4B;EAK5B;AAJF;;AAOA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB;AACF;;AAEA;EAGE,kCAAkC;EAGlC;AACF;;AAEA;EAEE;AACF;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAGb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EAEE,aAAa;EAEb,uBAAuB;EAEvB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAElB,cAAc;EACd;AACF;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EAEnB,yBAAyB;EACzB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;EAEE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kCAAkC;IAClC,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,8BAA8B;;AAE9B,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF","sourcesContent":[".submitBtn {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  background: rgba(30, 229, 118, 1) !important;\n  padding: 10px !important;\n  border-radius: 20px !important;\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n:root {\n  --accent-green: rgba(30, 229, 118, 1); /* same as submitBtn */\n  --text-dark: #000000;\n  --table-bg: #ffffff;\n  --table-header-bg: #046A38;\n  --table-header-border: rgba(30, 229, 118, 0.30);\n  --table-row-hover: rgba(30, 229, 118, 0.08);\n  --table-border: #e9ecef; /* close to Bootstrap's border color */\n}\n\n.table-theme {\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--text-dark);\n}\n\n.table-theme .table-card {\n  background: var(--table-bg);\n  border: 1px solid var(--table-border);\n  /* border-radius: 16px; */\n  box-shadow: 0 8px 24px rgba(0,0,0,0.06);\n}\n\n.table-theme .table {\n  margin: 0;\n  border-collapse: separate;       \n  border-spacing: 0;\n}\n\n/* .table-theme .table thead tr:first-child th:first-child {\n  border-top-left-radius: 16px;\n}\n.table-theme .table thead tr:first-child th:last-child {\n  border-top-right-radius: 16px;\n}\n.table-theme .table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 16px;\n}\n.table-theme .table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 16px;\n} */\n\n.table-theme .table thead th {\n  background: var(--table-header-bg);\n  border-bottom: 2px solid var(--table-header-border);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  text-transform: none;\n}\n\n.table-theme .table tbody td,\n.table-theme .table thead th {\n  padding: 8px 16px; /* visually aligned with your button’s comfort spacing */\n}\n\n.table-theme .table tbody tr:hover {\n  background: var(--table-row-hover);\n}\n\n.table-theme .table tbody tr + tr td {\n  border-top: 1px solid var(--table-border);\n}\n\n.table-theme .table tbody td.id-col {\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n.table-theme .badge-accent {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0f7a4d; /* readable on light background */\n  background: rgba(30, 229, 118, 0.18);\n  border: 1px solid rgba(30, 229, 118, 0.35);\n}\n\n.table-theme .btn-outline-accent {\n  color: var(--text-dark);\n  border-radius: 100px;\n  border: 1px solid rgba(0,0,0,0.12);\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  background: #fff;\n}\n.table-theme .btn-outline-accent:hover {\n  border-color: rgba(30, 229, 118, 0.8);\n  color: #0f7a4d;\n  background: rgba(30, 229, 118, 0.08);\n}\n\n.table-theme .btn-accent {\n  color: var(--text-dark) !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  text-align: center !important;\n  background: var(--accent-green) !important;\n  padding: 10px 18px;                \n  border-radius: 100px !important;\n  border: none !important;\n  cursor: pointer !important;\n}\n\n@media (max-width: 576px) {\n  .table-theme .table thead th,\n  .table-theme .table tbody td {\n    padding: 12px 12px;\n    font-size: 13px;\n  }\n  .table-theme .table thead th:last-child,\n  .table-theme .table tbody td:last-child {\n    white-space: nowrap;\n  }\n}\n\n/**Pagination **/\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n  padding: 16px 0;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.pagination {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.page-btn {\n  border: 1px solid #e5e7eb;\n  padding: 0;\n  border-radius: 8px;\n  cursor: pointer;\n  background-color: #fff;\n  color: #374151;\n  transition: all 0.2s ease;\n  min-height: 40px;\n  min-width: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.page-btn:hover:not(:disabled):not(.active) {\n  background-color: rgba(30, 229, 118, 0.08);\n  border-color: rgba(30, 229, 118, 0.3);\n  color: #046A38;\n}\n\n.page-btn.active {\n  background-color: #046A38;\n  color: #ffffff;\n  border-color: #046A38;\n  font-weight: 600;\n}\n\n.page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.nav-btn {\n  border-radius: 8px;\n  padding: 0;\n}\n\n.nav-btn svg {\n  display: block;\n}\n\n.ellipsis {\n  color: #9ca3af;\n  padding: 0 4px;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n}\n\n.pagination-info {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"DM Sans\", sans-serif;\n}\n\n@media (max-width: 640px) {\n  .pagination-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .pagination-info {\n    order: -1;\n    width: 100%;\n  }\n}\n/**Pagination **/\n\n/**Common add/edit modal css**/\n\n.modal {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  padding-top: 100px;\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\ndiv.userDetailsModal {\n  padding: 0 !important;\n  z-index: 9999;\n}\n/* Modal Content */\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n}\n\nbody.modal-open {\n  padding: 0 !important;\n}\n.lead-form .form-label {\n  margin: 16px 0 0 0;\n}\n\n.lead-form label {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  text-align: left;\n  color: rgba(102, 102, 102, 1);\n}\n\n/* .lead-form input[type=\"text\"],\n.lead-form input[type=\"email\"],\n.lead-form input[type=\"number\"] {\n  border-left: none;\n  border-right: none;\n  outline: none;\n  border-radius: 0;\n  border-top: none;\n  padding: 5px 0;\n  box-shadow: unset;\n} */\n\n.passwordInputs {\n  border-bottom: 1px solid #8C8C8C !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important;\n  border-radius: 0 !important;\n}\n\n.formInput.passwordInputs:focus {\n  box-shadow: none !important;\n}\n\n.branchSelect {\n  min-height: 35px ;\n  cursor: pointer;\n}\n\n.userDetailsModal .modal-body p:nth-child(2) {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px !important;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  color: #000000;\n}\n\n.userDetailsModal .modal-body p:nth-child(1) span {\n  font-family: \"Inter\", sans-serif;\n  letter-spacing: normal;\n  font-size: 12px;\n  color: #666;\n  font-weight: 400;\n  line-height: 18px\n}\n\n.userDetailsModal form.userDetailsModal .row.mt-4:has(.col-md-1) {\n  margin-top: 16px !important;\n  align-items: center !important;\n}\n\n.userDetailsModal label {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: normal;\n  text-align: left;\n  color: #222222 !important;\n  display: inline-block;\n}\n\n.userDetailsModal .form-control {\n  padding: 0 !important;\n  border-bottom-color: #8C8C8C;\n}\n\n#editUserModal .submitBtn:focus {\n    outline: 2px solid #222 !important;\n    outline-offset: 0px;\n    background-color: #00b140 !important;\n}\n#addUserModal .submitBtn:focus {\n    outline: 2px solid #222 !important;\n    outline-offset: 0px;\n    background-color: #00b140 !important;\n}\n#loading-image{\n  color: #000000;\n}\n\n.lead-form button {\n  color: #000000 !important;\n  font-family: \"DM Sans\", sans-serif !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  letter-spacing: normal !important;\n  text-align: center !important;\n  /* background: rgba(30, 229, 118, 1) !important; */\n  padding: 16px 35%;\n  /* border-radius: 100px !important; */\n  border: none !important;\n  cursor: pointer !important;\n  margin-top: 0;\n}\n\n.userDetailsModal .modal-body p span {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  line-height: 19.6px;\n  color: #414141;\n  font-weight: 400;\n  text-align: left;\n  letter-spacing: normal;\n}\n\n.userDetailsModal .btn-close {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n  width: 35px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  background: none;\n  opacity: 1;\n  border: 0;\n}\n.userDetailsModal .btn-close:focus,\n.userDetailsModal .btn-close:focus-visible {\n   outline: 2px solid black;\n    outline-offset: 2px;\n}\n\n.userDetailsModal .btn-close:before,\n.userDetailsModal .btn-close:after {\n  position: absolute;\n  top: 0;\n  content: ' ';\n  height: 24px;\n  width: 3px;\n  background-color: #333;\n  display: inline-block;\n}\n\n.userDetailsModal .btn-close:before {\n  transform: rotate(45deg);\n}\n\n.userDetailsModal .btn-close:after {\n  transform: rotate(-45deg);\n}\n\n.userDetailsModal .modal-header {\n  border-bottom: 0;\n  padding: 54px 56px 0 56px;\n  padding: 0;\n}\n\n.userDetailsModal .modal-body {\n  /* max-height: 60vh; */\n  height: auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-left: 5px;\n}\n\n.lead-form input[type=\"text\"],\n.lead-form input[type=\"email\"],\n.lead-form input[type=\"number\"] {\n  min-height: 35px !important;\n}\n\n/* width */\n.userDetailsModal::-webkit-scrollbar {\n  width: 2px;\n}\n\n/* Track */\n.userDetailsModal ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.userDetailsModal ::-webkit-scrollbar-thumb {\n  background: #414141;\n}\n\n/* Handle on hover */\n.userDetailsModal ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.bg-green{\n      background-color:  rgba(30, 229, 118, 1)  !important;\n    border: none !important;\n    color: #000000 !important;\n}\n.userDetailsModal .modal-title {\n  font-family: \"DM Sans\",sans-serif;\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 52.8px;\n  letter-spacing: normal;\n  text-align: left;\n  color: #222222;\n}\n\n.userDetailsModal span#myModalClose {\n  border-radius: 0;\n  padding: 0 !important;\n  margin-right: 10px !important;\n}\n\n.userDetailsModal.show{\n  display: block !important;\n}\n\n/* width */\n.userDetailsModal ::-webkit-scrollbar {\n  width: 2px;\n}\n\n/* Track */\n.userDetailsModal ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.userDetailsModal ::-webkit-scrollbar-thumb {\n  background: #414141;\n}\n\n/* Handle on hover */\n.userDetailsModal ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.modal {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  padding-top: unset;\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n}\n\n.modal-backdrop {\n  display: none;\n}\n\n.modal,\n.modal-open {\n  background: rgba(0, 0, 0, .5)\n}\n\n.modal,\n.modal-open {\n  overflow: hidden\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  outline: 0\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 8px !important;\n  pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n  transition: -webkit-transform .3s ease-out;\n  -webkit-transition: -webkit-transform .3s ease-out;\n  transition: transform .3s ease-out;\n  transition: transform .3s ease-out, -webkit-transform .3s ease-out;\n  -webkit-transform: translateY(-25%);\n  transform: translateY(-25%)\n}\n\n.modal.show .modal-dialog {\n  -webkit-transform: translate(0);\n  transform: translate(0)\n}\n\n.modal-dialog-centered {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  min-height: calc(100% - 16px)\n}\n\n.modal-content {\n  position: relative;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(28, 28, 28, .2);\n  border-radius: 16px;\n  outline: 0\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #1c1c1c\n}\n\n.modal-backdrop.fade {\n  opacity: 0\n}\n\n.modal-backdrop.show {\n  opacity: .5\n}\n\n.modal-header {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #e9ecef;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.55\n}\n\n.modal-body {\n  position: relative;\n  -webkit-box-flex: 1;\n  flex: 1 1 auto;\n  padding: 16px\n}\n\n.modal-footer {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  justify-content: flex-end;\n  padding: 16px;\n  border-top: 1px solid #e9ecef\n}\n\n.modal-footer>:not(:first-child) {\n  margin-left: .25rem\n}\n\n.modal-footer>:not(:last-child) {\n  margin-right: .25rem\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll\n}\n\n.modal-content {\n  color: #00703c\n}\n\n.modal-content .modal-body_title {\n  color: #00703c;\n  font-size: 36px\n}\n\n.modal-header {\n  border-bottom: none\n}\n\n.modal-body {\n  padding: 44px 16px 100px\n}\n\n.modal-section-padding {\n  padding-right: 17px\n}\n.userDetailsModal .submitBtn{\n  height: auto;\n}\n\n.userDetailsModal .submitBtn:hover, #editUserModal .submitBtn:focus {\n  background-color: #00B140 !important;\n}\n.userDetailsModal .modal-content{\n  padding: 64px 56px 56px;\n  border-radius: 16px;\n}\n\n\n.show {\n  display: block !important;\n}\n\n@media screen and (max-width: 600px) {\n  .lead-form button#submit_lead_data {\n    margin-top: 4px !important;\n    padding: 13px 0px;\n    width: 100%;\n  }\n}\n\n@media (min-width:576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 28px auto !important;\n    padding: 0;\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 56px)\n  }\n\n  .modal-sm {\n    max-width: 300px\n  }\n}\n\n@media (max-width: 767px) {\n\n  .userDetailsModal .modal-title {\n    font-size: 36px !important;\n    line-height: 38.52px !important;\n  }\n  .userDetailsModal .modal-content .modal-header{\n    padding: 24px 16px 16px;\n  }\n  .userDetailsModal .modal-body {\n    padding: 0 16px 16px;\n  }\n  .userDetailsModal .call-now-mob.d-block {\n    background: #000;\n    color: #fff !important;\n    width: 100%;\n    display: block !important;\n    padding: 16px 0;\n    border-radius: 40px;\n    text-align: center;\n    text-decoration: none;\n    margin-bottom: 26px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 22px;\n    text-transform: capitalize;\n    font-family: \"DM Sans\", sans-serif;\n    letter-spacing: normal;\n  }\n  .userDetailsModal .submitBtn {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .userDetailsModal .modal-content{\n    padding: 64px 16px 32px;\n  }\n}\n\n@media (min-width:720px) and (max-width:766px) {\n  button#submit_lead_data {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 800px !important;\n  }\n}\n\n@media (min-width:720px) and (max-width:766px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 500px !important;\n  }\n}\n\n@media (min-width:768px) and (max-width:991px) {\n  .userDetailsModal .modal-dialog {\n    max-width: 700px;\n  }\n\n  .userDetailsModal .show {\n    display: block !important;\n  }\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .userDetailsModal .modal-content {\n    width: 100% !important;\n  }\n\n  .userDetailsModal .modal-title {\n    font-size: 48px !important;\n  }\n}\n\n.invalid-feedback{\n  color: #D22B2B !important;\n  width: 100%;\n  margin-top: 4px !important;\n  font-size: 12px !important;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  line-height: 18px;\n  /* display: none; */\n}\n.userDetailsModal .btn-close:focus{\n  outline: 2px solid transparent !important;\n  box-shadow: none !important;\n}\n\n/**Common add/edit modal css**/\n\n/* MultiSelect Dropdown Styles */\n.tg-multiselect {\n  position: relative !important;\n  z-index: 1000 !important;\n}\n\n.userDetailsModal .tg-multiselect {\n  z-index: 1001 !important;\n}\n\n.tg-multiselect-panel {\n  z-index: 10000 !important;\n  max-width: 90vw !important;\n}\n\n/* Ensure modal body doesn't clip the dropdown */\n.userDetailsModal .modal-dialog {\n  overflow: visible !important;\n}\n\n.userDetailsModal .modal-content {\n  overflow: visible !important;\n}\n\n.userDetailsModal .modal-body {\n  overflow: visible !important;\n  position: relative;\n  z-index: auto;\n}\n\n/* Responsive styles for MultiSelect */\n@media (max-width: 576px) {\n  .tg-multiselect-panel {\n    max-width: 85vw !important;\n    max-height: 250px !important;\n  }\n  \n  .userDetailsModal .col-md-6 {\n    position: relative;\n    z-index: 1001;\n  }\n}\n\n@media (min-width: 577px) and (max-width: 768px) {\n  .tg-multiselect-panel {\n    max-width: 80vw !important;\n    max-height: 300px !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .tg-multiselect-panel {\n    max-width: auto !important;\n    max-height: 400px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submitBtn": `userDetails_submitBtn__9eIhd`,
	"table-theme": `userDetails_table-theme__TH1nM`,
	"table-card": `userDetails_table-card__qDSaS`,
	"table": `userDetails_table__nyIAA`,
	"id-col": `userDetails_id-col__g9YmY`,
	"badge-accent": `userDetails_badge-accent__wLK7r`,
	"btn-outline-accent": `userDetails_btn-outline-accent__2N4gE`,
	"btn-accent": `userDetails_btn-accent__tHEmO`,
	"pagination-wrapper": `userDetails_pagination-wrapper__NUJaA`,
	"pagination": `userDetails_pagination__V3WhT`,
	"page-btn": `userDetails_page-btn__ZDtpQ`,
	"active": `userDetails_active__4Ly5R`,
	"nav-btn": `userDetails_nav-btn__sGOW6`,
	"ellipsis": `userDetails_ellipsis__GFNZP`,
	"pagination-info": `userDetails_pagination-info__Myft1`,
	"modal": `userDetails_modal__nfq1X`,
	"userDetailsModal": `userDetails_userDetailsModal__Gmxhj`,
	"modal-content": `userDetails_modal-content__-KW69`,
	"modal-open": `userDetails_modal-open__MgBCm`,
	"lead-form": `userDetails_lead-form__1C2oy`,
	"form-label": `userDetails_form-label__kM8nD`,
	"passwordInputs": `userDetails_passwordInputs__COdS8`,
	"formInput": `userDetails_formInput__HnGqC`,
	"branchSelect": `userDetails_branchSelect__rpnVP`,
	"modal-body": `userDetails_modal-body__Hjlmj`,
	"row": `userDetails_row__GtKQo`,
	"mt-4": `userDetails_mt-4__xwesH`,
	"col-md-1": `userDetails_col-md-1__bn6AE`,
	"form-control": `userDetails_form-control__kPmXm`,
	"editUserModal": `userDetails_editUserModal__IIdbg`,
	"addUserModal": `userDetails_addUserModal__jOP-Y`,
	"loading-image": `userDetails_loading-image__fwDHS`,
	"btn-close": `userDetails_btn-close__axaxv`,
	"modal-header": `userDetails_modal-header__HInqw`,
	"bg-green": `userDetails_bg-green__RUUyc`,
	"modal-title": `userDetails_modal-title__MMWG0`,
	"myModalClose": `userDetails_myModalClose__brPnZ`,
	"show": `userDetails_show__lrV-1`,
	"modal-backdrop": `userDetails_modal-backdrop__jj43V`,
	"modal-dialog": `userDetails_modal-dialog__naTCE`,
	"fade": `userDetails_fade__AZ8a3`,
	"modal-dialog-centered": `userDetails_modal-dialog-centered__93EQh`,
	"modal-footer": `userDetails_modal-footer__CuS5b`,
	"modal-scrollbar-measure": `userDetails_modal-scrollbar-measure__t5gKa`,
	"modal-body_title": `userDetails_modal-body_title__CTMtP`,
	"modal-section-padding": `userDetails_modal-section-padding__ye6DC`,
	"submit_lead_data": `userDetails_submit_lead_data__I6Rrs`,
	"modal-sm": `userDetails_modal-sm__FANAl`,
	"call-now-mob": `userDetails_call-now-mob__21qy4`,
	"d-block": `userDetails_d-block__y4bJ0`,
	"invalid-feedback": `userDetails_invalid-feedback__aYESy`,
	"tg-multiselect": `userDetails_tg-multiselect__kNVAu`,
	"tg-multiselect-panel": `userDetails_tg-multiselect-panel__xymgW`,
	"col-md-6": `userDetails_col-md-6__kLSx3`
};
export default ___CSS_LOADER_EXPORT___;
